<!-- AI疾病予測　見出し -->
<template>
  <div class="heading" v-text="title" />
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    title: VueTypes.string.isRequired
  }
};
</script>

<style scoped>
.heading {
  text-align: left;
  background-color: #c5d7ef;
  padding: 10px;
  border-radius: 10px;
  font-size: calc(100vw / 70);
  font-weight: bold;
  padding-left: 10px;
}
</style>
